import { arrayOf, Schema } from 'normalizr';


export const SITE_ARTICLE_SCHEMA = new Schema('siteArticles');

export const SITE_ARTICLES_SCHEMA = {
  items: arrayOf(SITE_ARTICLE_SCHEMA),
};
